import { useMutation, useQueryClient } from 'react-query';
import makeApiRequest from 'services/makeApiRequest';
import apiEndPoints from 'services/apiEndPoints';
import { ErrorToast, SuccessToast } from 'services/toasterService';
export default function useDeleteFolder(cb) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.delete(apiEndPoints.MAILS_FOLDER, {
        data: data,
      });
      return response?.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('get-mail-folders');

        SuccessToast({ text: data?.message });
        cb();
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
        cb();
      },
    }
  );
}
